import { render } from "./YellowMeetingList.vue?vue&type=template&id=054ce07a"
import script from "./YellowMeetingList.vue?vue&type=script&lang=js"
export * from "./YellowMeetingList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__